import { render, staticRenderFns } from "./DecayTab.vue?vue&type=template&id=66f1fd46&scoped=true"
import script from "./DecayTab.vue?vue&type=script&lang=js"
export * from "./DecayTab.vue?vue&type=script&lang=js"
import style0 from "./DecayTab.vue?vue&type=style&index=0&id=66f1fd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1fd46",
  null
  
)

export default component.exports